import AppDetailsPage from '@/pages/App/AppDetails/AppDetailsPage';

import { renderPageComponent } from '@/utils/react_page';
renderPageComponent(AppDetailsPage);